export default __webpack_public_path__ + "static/media/icon-logout.518e1c0c.svg";